/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Country } from 'components/Countries/Country'
import { group } from 'd3-array'
import { scaleThreshold } from 'd3-scale'
import { ChapterNavigation } from 'components/ChapterNavigation'
import { Box } from 'components/Box'
import GetSheetDone from 'get-sheet-done'
import Papa from 'papaparse'
import csvjson from 'csvjson'
import { parseText } from 'components/_utils'
// TODO Set the correct article ID here
const ARTICLE_ID = '910697129406'
const DATAPROP = 'Incidence7day'
const CUMULATEDPROP = 'CumulativePositive'
const CUMULATED7PROP = 'Positive7day'
const DATEPROP = 'DateRpt'

const colorScale = scaleThreshold<string, string, string>()
  .domain([20, 60, 200, 400, 800, 1600, 3200])
  .range([
    '#E9E9E9',
    '#F1BE8D',
    '#E78D38',
    '#E16D00',
    '#D3343F',
    '#9E272F',
    '#691A1F'
  ])

const ChapterNavigationContent = [
  {
    name: <>Europa</>,
    id: 'EU'
  },
  {
    name: <>Deutschland</>,
    id: 'DE'
  },
  {
    name: <>Frankreich</>,
    id: 'FR'
  },
  {
    name: <>Österreich</>,
    id: 'AT'
  },
  {
    name: <>Italien</>,
    id: 'IT'
  },
  {
    name: <>Spanien</>,
    id: 'ES'
  }
]
const notInIntro = ['country', 'iso3', 'name', 'main', 'block4title', 'block4']
export function AppComponent() {
  const [sheetdata, setSheetData] = useState<countryElement[] | undefined>()
  const [chData, setChData] = useState<dataElement[] | undefined>()
  const [maintext, setMainText] = useState<string>('')
  const [currentChapter, setCurrentChapter] = useState('EU')
  const [date, setDate] = useState<string>('20. April 2021')
  const [moreinfos, setMoreInfos] = useState<string[] | undefined>()
  const [important, setImportant] = useState<string[] | undefined>()
  const [vaccBoxContent, setVaccBox] = useState<[string, string] | undefined>()
  useEffect(() => {
    fetch(
      'https://docs.google.com/spreadsheets/d/e/2PACX-1vTPwZltNn74e8X1KtjxAe4Ob5GOjPdMmEkSeqmNN9zUY2V8pphX47tJXtvmxG8xT8LMxt37AxIdM42K/pub?gid=0&single=true&output=csv'
    )
      .then(res => res.text())
      // .then(data => csvjson.toObject(data, {}))
      .then(data => {
        fetch(
          'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/europe-subnational.csv?a=12'
        )
          .then(response => {
            return response.text()
          })
          .then(csv => {
            let sheetd = Papa.parse(data, { header: true }).data

            const intro = sheetd.shift()
            const raw = csvjson.toObject(csv, {}).map((m: any) => ({
              iso3: m.iso3,
              id: m.UID,
              color: colorScale(+m[DATAPROP]),
              val: +m[DATAPROP],
              name: m.Region,
              cum: +m[CUMULATEDPROP],
              cum7: +m[CUMULATED7PROP],
              date: m[DATEPROP]
            }))
            const subnational = group(raw, d => d.iso3)
            const enricheddata = sheetd
              .filter(f => f.country)
              .map(m => {
                m.subnational = subnational.get(m.iso3)
                return m
              })
            setDate(intro.name)
            setMoreInfos(
              Object.entries(intro)
                .filter(f => notInIntro.indexOf(f[0]) === -1 && f[1] !== '')
                .map(m => m[1])
            )
            const vacc = sheetd.filter(f => f.country === 'vacc')[0]
            setVaccBox([vacc.name, vacc.main])
            setImportant([intro.block4title, intro.block4])
            setMainText(intro.main)
            setChData(raw)
            console.log(raw)
            enricheddata.pop()
            setSheetData(enricheddata)
          })
      })
      .catch(err => {
        console.log('Error')
        console.error(err)
      })
  }, [])

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Im Winter ins Ausland? In diese Länder können Sie reisen</h1>
            <h2>
              Wir zeigen, welche Lieblingsreiseländer der Schweizer aktuell
              offen sind, welche Reisebestimmungen gelten und was vor Ort zu
              erwarten ist.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <ChapterNavigation
          content={ChapterNavigationContent}
          current={currentChapter}
        />
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Jonathan Spirig, Sebastian Broschinski
            </div>
            <div className='ta updated'>
              Aktualisiert am {date}, Karten werden täglich aktualisiert
            </div>
          </div>
        </div>
        <div className=' europe'>
          <div className='swissholder'>
            {chData && (
              <Country
                data={{
                  block1: '',
                  block1title: '',
                  country: 'EU',
                  iso3: 'CHE',
                  main: '',
                  name: '',
                  subnational: chData
                }}
                maponly
                colorkeydata={[colorScale.domain(), colorScale.range()]}
                setCurrent={setCurrentChapter}
              />
            )}
          </div>
        </div>
        <div className='ui text container'>
          <div className='ta text'>
            {maintext && <>{parseText(maintext)}</>}
            {vaccBoxContent && (
              <Box
                title={vaccBoxContent[0]}
                content={parseText(vaccBoxContent[1])}
              />
            )}

            {important && (
              <div className='important'>
                <div className='text'>
                  <b>{important[0]}: </b>
                  {important[1]}
                </div>
              </div>
            )}
          </div>
        </div>
        {sheetdata !== undefined &&
          sheetdata.map(m => {
            return (
              <Country
                data={m}
                colorkeydata={[colorScale.domain(), colorScale.range()]}
                setCurrent={setCurrentChapter}
              />
            )
          })}
        <div className='ui text container'>
          <div className='ta text'>
            <div className='hints'>
              <div className='title'>Weiterführende Informationen:</div>
              {moreinfos &&
                moreinfos.map(m => <div className='hint'>{parseText(m)}</div>)}
            </div>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Text', 'Jonathan Spirig, Travelcontent'],
          ['Konzept und Umsetzung', 'Sebastian Broschinski, Interaktiv-Team'],
          [
            'Daten',
            'WHO, European Centre for Disease Prevention and Control, BAG, Kantone'
          ]
        ]}
      />
    </div>
  )
}
